export enum HeaderVisualizationType {
    INVESTOR = 'INVESTOR',
    SECONDARY_ACCESS = 'SECONDARY_ACCESS'
}